var map = {
	"./KNET.svg": 904,
	"./VISA.svg": 905
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 903;


//////////////////
// WEBPACK FOOTER
// ./src/images/svgs/PaymentModes ^\.\/.*$
// module id = 903
// module chunks = 0